import { render, staticRenderFns } from "./receipt-mobile-header-cta.vue?vue&type=template&id=37878762&scoped=true"
import script from "./receipt-mobile-header-cta.vue?vue&type=script&lang=ts"
export * from "./receipt-mobile-header-cta.vue?vue&type=script&lang=ts"
import style0 from "./receipt-mobile-header-cta.vue?vue&type=style&index=0&id=37878762&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37878762",
  null
  
)

export default component.exports